import { useEffect, useState } from 'react';

interface WindowSize {
  width: number;
  height: number;
}

function getWindowSize({ width = 0, height = 0 }: Partial<WindowSize> = {}): WindowSize {
  if (window) {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  return { width, height };
}

function useWindowSize(defaultValue?: Partial<WindowSize>): WindowSize {
  const [windowSize, setWindowSize] = useState(getWindowSize(defaultValue));

  function handleResize() {
    setWindowSize(getWindowSize(defaultValue));
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
}

export default useWindowSize;
